/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/


define (["underscore", "backbone", "utils/jsonpath", "api/v2/common"],
    function(_, Backbone, JSONPath, Common) {

  var PropertiesModel = function(properties, options) {
    options = options || {};
    // console.log("properties", properties);
    this.formatProvider = options.formatProvider || Common.PropertyFormat;
    this.defaultFormat = options.defaultFormat || "VALUE";
    this.propertyDefinitions = options.propertyDefinitions;
    this.cid = _.uniqueId('c');
    this.properties = {};
    this.load(properties, _.extend({silent:true}), options);
  };

  _.extend(PropertiesModel.prototype, Backbone.Events, {

    idAttribute: "id",

    // **load** reinitializes the tree from attributes, parses first
    load: function(properties, options) {
      options = options || {};
      var props = properties || {};

         if (this.idAttribute in props) {
           this.id = props.id;
         }
//
//      if (options.parse) {
//        atts = this.parse(attributes);
//      }
//      if (options.merge) {
//        var existingAtts = _.clone(this.attributes);
//        atts = this.merge(existingAtts, atts);
//      }

      // overwrite the attributes
      this.properties = props;

      if (!options.silent) {
          // console.log("trigger change");
          this.trigger("change", this, this.properties, options);
      }
    },

    clone: function () {
      return new PropertiesModel(_.clone(this.properties), { propertyDefinitions: this.propertyDefinitions });
    },

    merge: function(attributes, newatts) {
    },

    // TODO: reset, update? vs load, merge
    // **reset** reinitializes the tree from attributes, parses first
    reset: function(properties, options) {
      options = options || {};
      var result = this.load(properties, options);
      if (!options.silent) {
        // console.log("trigger change");
        this.trigger("reset", this, this.properties, options);
      }
      return result;
    },

    /// **submodel** returns the value of an attribute.
    submodel: function(attr, options) {
      if (attr == undefined) return this;

      var props = this.get(attr, options);
      // console.log(attr);
      // console.log(JSON.stringify(props, null, 1));
      return new PropertiesModel(props, this.options);
    },

    /// **get** returns the value of an attribute.
    get: function(attr, options) {

      if (attr == undefined) return this.properties;
      var options = options || {};
      var format = options.format || this.defaultFormat;
      if (this.propertyDefinitions && !options.overridePropertyFormat) {
        if (this.propertyDefinitions[attr] && this.propertyDefinitions[attr].format) {
          // console.log("propertyDefinitions for attr ", attr,  this.propertyDefinitions[attr].format);
          format = this.propertyDefinitions[attr].format;
        }
      }

      // console.log("path", attr);
      var valueAsFallback = false;
      var property = this.properties;
      var restOfPath = [];
      if (attr != ".") {

        // resolve symbolic offsets
        var pattern = /\[\s*([a-zA-Z_]\w*)\s*\]/g;
        var matchresult;
        var newAttr = "";
        var lastindex = 0;
        while ((matchresult = pattern.exec(attr)) !== null) {
          var index = matchresult.index;
          var length = matchresult[0].length;
          var key = matchresult[1];
          var value = this.get(key);
          newAttr += attr.substr(lastindex, index - lastindex);
          newAttr += "[" + JSON.stringify(value) + "]";
          lastindex = index + length;
        }
        attr = lastindex == 0 ? attr : newAttr + attr.substr(lastindex);
        
        var path = JSONPath.parsePath(attr);
        if (!path) {
          throw new Error("Failed to parse JSON path: " + attr);
        }

        var i = 0;

        // 1st try exact match (e.g. title)
        for (; i < path.length; ++i) {
          // console.log(i, path[i]);
          if (_.isNumber(path[i]) && !_.isArray(property)) break;

          var isLastPathElement = i == path.length - 1 ;
          var nextProperty = JSONPath.get(property, [path[i]]);
          if (nextProperty == null) {
              break;
          }

          if (!isLastPathElement) {
            var lookAhead = JSONPath.get(nextProperty, [path[i + 1]]);
            if (lookAhead == null) {
              var nextPathIsNumber = path.length - 1 > i && (_.isNumber(path[i + 1]) || !_.isNaN(parseInt(path[i + 1])));
              var nextIsLastElement = path.length - 2 == i;
              if (!nextIsLastElement || !nextPathIsNumber) {
                // Test to get the property via format
                var that = this,
                    lookAheadAsFormat = _.reduce(["PROPERTY", "VALUE"],function (result,format) {
                  if (result != null) return result;
                  var nextPropertyAsFormat = that.formatProvider.forFormat(format, nextProperty);
                  if (nextPropertyAsFormat == null) return null;

                  if (_.isArray(nextPropertyAsFormat) && nextPropertyAsFormat.length == 1
                      && (!_.isNumber(path[i + 1]) || _.isNaN(parseInt(path[i + 1])))) {
                    nextPropertyAsFormat = nextPropertyAsFormat[0];
                  }
                  return JSONPath.get(nextPropertyAsFormat, [path[i + 1]]);
                }, null);

                if (lookAheadAsFormat != null) {
                  nextProperty = lookAheadAsFormat;
                  i = i + 1;
                }
              }
            }
          }
          property = nextProperty;
        }
        restOfPath = path.slice(i);
        // 2nd try to get the value of the kind
        if (restOfPath.length > 0) {
          if (format != "PROPERTY") {
            format = "VALUE"; // HTML cannot have a sub path..
            valueAsFallback = true;
          }
        }
      }
      /*
      console.log("attr", attr);
      console.log("oprtions.format", options.format);
      console.log("format", format);

      console.log("restOfPath", JSON.stringify(restOfPath));

      console.log("format", format);
      console.log("this.properties", JSON.stringify(this.properties,null,1));
      console.log("property", JSON.stringify(property, null, 1));
      */

      var value = this.formatProvider.forFormat(format, property);

      // console.log("value", JSON.stringify(value, null, 1));
      if (format != "VALUE" && property != null && value == undefined) {
        value = this.formatProvider.forFormat("VALUE", property);
      }
      if (property != null && value == undefined) {
        value = property;
      }

      if (value != null && format == "PROPERTY" && options.format && options.format != "PROPERTY") {
        format = options.format;
        if (_.isArray(value)) {
          var that = this;
          value = _.flatten(_.map(value, function(value) { return that.formatProvider.forFormat(options.format, value); } ));
        }
        else {
          value = this.formatProvider.forFormat(options.format, value);
        }
      }

      if (restOfPath != null && restOfPath.length > 0 ) {
        var result = undefined;
        if (_.isArray(value) && value.length == 1) {
          result = JSONPath.get(value[0], restOfPath);
        }
        if (result === undefined) {
          result = JSONPath.get(value, restOfPath);
        }

        // TODO: Back-add support in JSONPath for associative lists, this should also work in this case.
        if (result == undefined && Common.isPropertyArray(value)) {
          var temp = {};
          Common.Properties.parse(temp, value);
          result = JSONPath.get(temp, restOfPath);
          if (_.isObject(result) && options.format != "PROPERTY") {
            result = this.formatProvider.forFormat(valueAsFallback ? options.format : format, result);
          }
        }

        return result;
      }

      if (_.isArray(value) && value.length == 1)
        return value[0];

      return value;
    }

});

PropertiesModel.extend = Backbone.Model.extend;

PropertiesModel.fromAttsAndProperties = function (atts, properties, propertyDefinitions) {
  var propdefs = {};
  var keys = _.keys(propertyDefinitions);
  var that = this;
  _.each(keys, function(propName) {
      var propertyDef  = propertyDefinitions[propName];
      var propRoot     = propertyDef.root;
      var propPathRest = propertyDef.path;
      var propFormat   = propertyDef.format;

      var prop = properties && properties[propRoot];
      if (prop !== undefined) atts[propRoot] = prop;
      propdefs[propName] = {format: propFormat};
  });
  return new PropertiesModel(atts, {propertyDefinitions: propdefs });
};


return PropertiesModel;

});
